// extracted by mini-css-extract-plugin
export default {"card":"components-hotel-net-revenue-stay-date-chart-module__card","card-message":"components-hotel-net-revenue-stay-date-chart-module__card-message"};